import { render, staticRenderFns } from "./SupportingDocument-Profile.vue.vue?vue&type=template&id=90cac4aa&"
import script from "./SupportingDocument-Profile.vue.vue?vue&type=script&lang=js&"
export * from "./SupportingDocument-Profile.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports